import {Button, Divider} from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import uuidv4 from 'uuid/v4';
import './MainServices.css';
import LabelEncoder from './LabelEncoder';
import CheckboxItem from './CheckboxItem';
import {SpinnerModal} from '../../public/components/SpinnerModal';
import withAuthorization from '../../services/Authorization';
import Constants from '../../services/Constants';
import Storage from '../../services/Storage'

const MAX_SERVICES_TO_ADD = 4;
const MAX_MY_BMW_APP_EXTRA_SERVICE = 10;

class MainServices extends Component {

  static propTypes = {
    dispatchFetchServices: PropTypes.func.isRequired,
    dispatchSaveServices: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      services: {
        additionalServices: [],
        extraServices: [],
        mainServices: [],
        myBMWAppExtraServices: [],
        myBMWAppServices: [],
        otherServices: []
      },
      additionalServiceId: 0
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const getDerivedStateFromPropsService = (services) => {
      const newState = {services};
      if (services.extraServices && services.extraServices.length >= 1) {
        const maxId = _.maxBy(services.extraServices, (b) => b.id);
        newState.additionalServiceId = maxId.id + 1;
      }
      return newState;
    }
    const saveServices = nextProps.saveServices && nextProps.saveServices.services && Object.keys(nextProps.saveServices.services).length ? nextProps.saveServices.services : undefined;
    if (saveServices && saveServices !== prevState.services) {
      return getDerivedStateFromPropsService(saveServices);
    }
    const fetchServices = nextProps.fetchServices && nextProps.fetchServices.services
    if (!saveServices && fetchServices && fetchServices !== prevState.services) {
      return getDerivedStateFromPropsService(fetchServices);
    }
    return null;
  }

  componentDidMount() {
    this.props.dispatchFetchServices();
  }

  formatError(wrapper, name, error) {
    return {
      [`${name}.category`]: error[`${wrapper}[${name}].category`],
      [`${name}.categoryCode`]: error[`${wrapper}[${name}].categoryCode`],
      [`${name}.duration`]: error[`${wrapper}[${name}].duration`],
      [`${name}.price`]: error[`${wrapper}[${name}].price`],
      [`${name}.rangeOfKilometers`]: error[`${wrapper}[${name}].rangeOfKilometers`]
    };
  }

  onCheckboxItemChange = (category, name, item) => {
    const {services} = this.state;
    services[category][name] = item;
    this.setState({services});
  }

  onSaveAdditionalService = (category, values, counter) => {
    const {services} = this.state;
    if (!services[category]) {
      services[category] = [];
    }
    const service = services[category].find(service => service.id === values.id)
    if (service) {
      service.mlItem = values;
    } else {
      services[category].push({
        active: true,
        id: values.id,
        mlItem: values,
        order: services[category].length
      });
    }
    this.setState({
      services,
      additionalServiceId: counter ? this.state.additionalServiceId + 1 : this.state.additionalServiceId
    });
  }

  removeAdditionalService = (category, id) => {
    const {services} = this.state;
    services[category] = services[category].filter(e => id !== e.id);
    services[category].forEach((service, i) => service.order = i);
    this.setState({services});
  }

  save = () => {
    this.props.dispatchSaveServices(this.state.services);
  }

  render() {
    const {intl: {formatMessage}, loading, saveServices, configurationHints} = this.props;
    const {additionalServices = {}, mainServices = {}, myBMWAppServices = {}, otherServices = {}} = this.state.services;
    const {error: {content: errors = {}} = {}} = saveServices;
    const canWrite = Storage.getItem('user').role === 'DUI_ADMIN';
    const canAddService = canWrite && (this.state.services.extraServices || []).length < MAX_SERVICES_TO_ADD;
    const canAddMyBmwAppExtraService = canWrite && (this.state.services.myBMWAppExtraServices || []).length < MAX_MY_BMW_APP_EXTRA_SERVICE;

    const requiredConfig = configurationHints.includes('SERVICES');

    const additionalServicesList = Object.values(additionalServices).sort((a, b) => a.order - b.order);
    const mainServicesList = Object.values(mainServices).sort((a, b) => a.order - b.order);
    const myBMWAppServicesList = Object.values(myBMWAppServices).sort((a, b) => a.order - b.order);
    const otherServicesList = Object.values(otherServices).sort((a, b) => a.order - b.order);

    return (
      <section className="box main-services">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id: 'section.main-services.title'})}
          </h2>
          {canWrite &&
            <div className="box-heading__button">
              <button onClick={this.save} disabled={loading} type="primary" className="btn btn-sm btn-primary">
                {formatMessage({id: 'action.save'})}
              </button>
            </div>
          }
        </header>
        <div className="box__body">
          <SpinnerModal visible={loading}/>

          {requiredConfig &&
            <div className={"alert alert--error"}>
              {formatMessage({id: 'section.requires-configuration'}, {sectionName: formatMessage({id: 'section.main-services.maintenance.title'})})}
            </div>
          }

          <div className="row">
            <div className="col-sm-12 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id: 'section.main-services.maintenance.title'})}</h3>
              <ul className="list li-margin">

                {mainServicesList.map((service) =>
                  <li key={service.name}>
                    <CheckboxItem canWrite={canWrite} name={service.name} item={service} labelKey={`services.${service.name}`}
                                  config={{categoryCode: true, timePicker: true}}
                                  onChange={(name, item) => this.onCheckboxItemChange('mainServices', name, item)}
                                  error={this.formatError('mainServices', service.name, errors)}
                    />
                  </li>
                )}
              </ul>
            </div>
            <div className="col-sm-12 col-xxl-6 mt-sm-5 mt-xxl-0">
              <h3 className="box__subtitle">{formatMessage({id: 'section.main-services.other.title'})}</h3>
              <ul className="list li-margin">
                {otherServicesList.map(service =>
                  <li key={service.name}>
                    <CheckboxItem canWrite={canWrite} name={service.name} item={service} labelKey={`services.${service.name}`}
                                  config={{category: true, categoryCode: true, timePicker: true}}
                                  onChange={(name, item) => this.onCheckboxItemChange('otherServices', name, item)}
                                  error={this.formatError('otherServices', service.name, errors)}
                    />
                  </li>
                )}
              </ul>
            </div>
          </div>
          <Divider className="b-xxl"/>
          <div className="row">
            <div className="col-sm-12 col-xxl-6 mt-sm-5 mt-xxl-0">
              <h3 className="box__subtitle">
                {`${formatMessage({id: 'section.additional-services.title'})} (${formatMessage({id: 'include.vat'})})`}
              </h3>
              <ul className="list li-margin">
                {additionalServicesList.map(service =>
                  <li key={service.name}>
                    <CheckboxItem canWrite={canWrite} name={service.name} item={service} labelKey={`services.${service.name}`}
                                  config={{category: true, categoryCode: true, price: true, timePicker: true}}
                                  onChange={(name, item) => this.onCheckboxItemChange('additionalServices', name, item)}
                                  error={this.formatError('additionalServices', service.name, errors)}
                    />
                  </li>
                )}
              </ul>
            </div>
            <div className="col-sm-12 col-xxl-6 mt-sm-5 mt-xxl-0">
              <h3 className="box__subtitle">
                {`${formatMessage({id: 'section.extra-services.title'})} (${formatMessage({id: 'include.vat'})})`}
              </h3>
              <ul className="list li-margin">
                {(this.state.services.extraServices || []).map((service, i) =>
                  <li key={'service.' + i}>
                    <CheckboxItem canEditMLItem={canWrite} canWrite={canWrite} name={i} item={service} labelKey={service['mlItem'][this.props.intl.locale]} disabled={true}
                                  error={this.formatError('extraServices', i, errors)}
                                  config={{category: true, categoryCode: true, price: true, timePicker: true}}
                                  onChange={(name, item) => this.onCheckboxItemChange('extraServices', i, item)}
                                  onRemoveMLItem={() => this.removeAdditionalService('extraServices', service.id)}
                                  onSaveMLItem={(values) => this.onSaveAdditionalService('extraServices', values, false)}
                    />
                  </li>
                )}
                {canAddService &&
                  <li className="list__footer">
                    <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={this.state.additionalServiceId} onValidate={(values) => this.onSaveAdditionalService('extraServices', values, true)}>
                      <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                        <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                          <use xlinkHref="#icon-plus"/>
                        </svg>
                        <strong>{formatMessage({id: 'add.more'})}</strong>
                      </Button>
                    </LabelEncoder>
                  </li>}
              </ul>
            </div>
          </div>
          <Divider className="b-xxl"/>
          <div>
            <div className="row">
              <div className="col-sm-12 col-xxl-6 mt-sm-5 mt-xxl-0">
                <h3 className="box__subtitle">
                  {`${formatMessage({id: 'section.my-bmw-app-services.title'})}`}
                </h3>
                <ul className="list li-margin">
                  {myBMWAppServicesList.map(service =>
                    <li key={service.name}>
                      <CheckboxItem canWrite={canWrite} name={service.name} item={service} labelKey={`services.${service.name}`}
                                    error={this.formatError('myBMWAppServices', service.name, errors)}
                                    config={{category: true, categoryCode: true, timePicker: true}}
                                    disabled={service.status === 'DISABLED'}
                                    onChange={(name, item) => this.onCheckboxItemChange('myBMWAppServices', name, item)}/>
                    </li>
                  )}
                </ul>
              </div>
              <div className="col-sm-12 col-xxl-6 mt-sm-5 mt-xxl-0">
                <h3 className="box__subtitle">
                  {`${formatMessage({id: 'section.my-bmw-app-extra-services.title'})}`}
                </h3>
                <ul className="list li-margin">
                  {(this.state.services.myBMWAppExtraServices || []).map((service, i) =>
                    <li key={'myBMWAppExtraServices.' + i}>
                      <CheckboxItem canEditMLItem={canWrite} canWrite={canWrite} name={i} item={service} labelKey={service['mlItem'][this.props.intl.locale]} disabled={true}
                                    error={this.formatError('myBMWAppExtraServices', i, errors)}
                                    config={{category: true, categoryCode: true, timePicker: true}}
                                    onChange={(name, item) => this.onCheckboxItemChange('myBMWAppExtraServices', service.id, item)}
                                    onRemoveMLItem={() => this.removeAdditionalService('myBMWAppExtraServices', service.id)}
                                    onSaveMLItem={(values) => this.onSaveAdditionalService('myBMWAppExtraServices', values, false)}
                      />
                    </li>
                  )}
                  {canAddMyBmwAppExtraService &&
                    <li className="list__footer">
                      <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={uuidv4()} onValidate={(values) => this.onSaveAdditionalService('myBMWAppExtraServices', values, false)}>
                        <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                          <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                            <use xlinkHref="#icon-plus"/>
                          </svg>
                          <strong>{formatMessage({id: 'add.more'})}</strong>
                        </Button>
                      </LabelEncoder>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  configurationHints: (state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints) || [],
  fetchServices: state.fetchServices,
  saveServices: state.saveServices,
  loading: state.fetchServices.loading || state.saveServices.loading
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchServices: (parameters, filters) => dispatch({type: 'FETCH_SERVICES.REQUEST', parameters, filters}),
  dispatchSaveServices: (body) => dispatch({type: 'SAVE_SERVICES.REQUEST', body})
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withAuthorization(MainServices, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR'])));
